import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { CreateQuoteStep1 } from '../../quotes/otherQuoteEntities';
import { PriceZoneSummary } from '../../price-zones/priceZone';
import { TextMosaic, TextMosaicDto, MosaicWall } from '@ami/react/core';

export default class CreateQuoteStep1PriceZone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOtherSelected: false,
    };
  }
  static propTypes = {
    data: PropTypes.instanceOf(CreateQuoteStep1).isRequired,
    onUpdate: PropTypes.func.isRequired,
    priceZones: PropTypes.arrayOf(PropTypes.instanceOf(PriceZoneSummary))
      .isRequired,
  };
  render() {
    const { data, onUpdate, priceZones } = this.props;
    const anyProminent = priceZones.some((x) => x.isProminent);
    return (
      <Fragment>
        {anyProminent && (
          <MosaicWall
            childrenContainerClassName={`row d-flex justify-content-center ${
              data.priceZoneId ? '' : 'invalid'
            }`}
            placeholder="Please select a price zone"
          >
            {priceZones
              .filter((x) => x.isProminent)
              .map((x) => (
                <TextMosaic
                  key={x.id}
                  data={
                    new TextMosaicDto({
                      label: x.label,
                      selected: x.id === data.priceZoneId,
                      padding: 'p-3',
                    })
                  }
                  widthColumns={4}
                  onClick={() => {
                    onUpdate({ priceZoneId: x.id });
                    this.setState({ isOtherSelected: false });
                  }}
                />
              ))}
            {priceZones.filter((x) => !x.isProminent).length > 0 && (
              <TextMosaic
                data={
                  new TextMosaicDto({
                    label: 'Other',
                    selected: this.state.isOtherSelected,
                    padding: 'p-3',
                  })
                }
                onClick={() => {
                  onUpdate({ priceZoneId: null });
                  this.setState({ isOtherSelected: true });
                }}
                widthColumns={4}
              />
            )}
          </MosaicWall>
        )}
        {(this.state.isOtherSelected || !anyProminent) && (
          <div className="row text-center mt-1">
            <MosaicWall
              childrenContainerClassName={`row d-flex justify-content-center ${
                data.priceZoneId ? '' : 'invalid'
              }`}
              placeholder="Please select a price zone"
            >
              {priceZones
                .filter((x) => !x.isProminent)
                .map((x) => (
                  <TextMosaic
                    key={x.id}
                    data={
                      new TextMosaicDto({
                        label: x.label,
                        description: x.description,
                        selected: x.id === data.priceZoneId,
                        padding: 'p-3',
                      })
                    }
                    onClick={() => {
                      onUpdate({ priceZoneId: x.id });
                    }}
                    active={data.priceZoneId === x.id}
                    widthColumns={4}
                  />
                ))}
            </MosaicWall>
          </div>
        )}
      </Fragment>
    );
  }
}
